import React from 'react';
import { useInput, InputHelperText, FieldTitle } from 'react-admin';

import TextField from '@material-ui/core/TextField';

import InputTemplate from './Template';

export const CpfInput = (props) => (
  <InputTemplate {...props} formato="###.###.###-##" />
);

export const CepInput = (props) => (
  <InputTemplate {...props} formato="#####-###" />
);

export const NfeInput = (props) => (
  <InputTemplate {...props} formato="###.###.###" />
);

export const ChaveAcessoNfeInput = (props) => (
  <InputTemplate
    {...props}
    formato="#### #### #### #### #### #### #### #### #### #### ####"
  />
);

export const CnpjInput = (props) => (
  <InputTemplate {...props} formato="##.###.###/####-##" />
);

export const CodigoInternoInput = (props) => (
  <InputTemplate {...props} formato="######" />
);

export const IEInput = (props) => (
  <InputTemplate {...props} formato="###.###.###" />
);

export const IntegerInput = (props) => <InputTemplate {...props} />;

export const FloatInput = (props) => (
  <InputTemplate {...props} escala={2} sufixo="" />
);

export const PesoInput = (props) => (
  <InputTemplate {...props} escala={3} sufixo="Kg" />
);

export const AreaInput = (props) => (
  <InputTemplate {...props} escala={2} sufixo="M2" />
);

export const PesoGramasInput = (props) => (
  <InputTemplate {...props} sufixo="g" />
);

export const PorcentagemInput = (props) => (
  <InputTemplate {...props} escala={3} sufixo="%" />
);

export const PrecoInput = (props) => (
  <InputTemplate {...props} escala={2} prefixo="R$: " />
);

export const TelefoneInput = (props) => (
  <InputTemplate {...props} formato="(##) #####-####" />
);

export { default as PeriodoInput } from './PeriodoInput';

export { default as PeriodoRapidoInput } from './PeriodoRapidoInput';

export { default as FornecedorPastaInput } from './FornecedorPastaInput';

export { default as CompetenciaInput } from './CompetenciaInput';

function applyTeclaMask(value) {
  const raw = String(value || '')
    .replace(/-/g, '')
    .slice(0, 4);
  if (raw.length <= 2) return raw;
  return `${raw.slice(0, 2)}-${raw.slice(2)}`;
}

export const TeclaInput = ({ ...rest }) => {
  const {
    id,
    input: { name, onChange, value, ...rest2 },
    meta: { touched, error },
    isRequired,
  } = useInput({
    ...rest,
  });

  const handleChange = (e) => {
    const masked = applyTeclaMask(e.target.value);
    onChange({ ...e, target: { ...e.target, value: masked } });
  };

  return (
    <TextField
      id={id}
      name={name}
      value={applyTeclaMask(value)}
      onChange={handleChange}
      variant="filled"
      error={!!(touched && error)}
      helperText={
        <InputHelperText
          touched={touched}
          error={error}
          helperText={rest.helperText}
        />
      }
      label={
        <FieldTitle
          label={rest.label}
          source={rest.source}
          resource={rest.resource}
          isRequired={isRequired}
        />
      }
      margin="dense"
      inputProps={{ maxLength: 5 }}
      {...rest2}
    />
  );
};
